import { setActiveCompany } from './cookie-utils'

export function companySelected(companyID: string | null) {
  setActiveCompany(companyID ?? null)
}
